import { useUnit } from 'effector-react';
import $$auth from 'models/auth';
import $$ep from 'models/ep';
import { $global } from 'models/store-global';
import { useEffect } from 'react';

import CookieService from 'services/CookieService';
import TempUsersService from 'services/TempUsersService';

import useCookieChange from 'hooks/useCookieChange';

const cookieName = 'promotionUserState';

const useMarketingModalStates = () => {
    const userRole = useUnit($global.map((state) => state.auth?.userRole || 'guest'));
    const initialized = useUnit($global.map((state) => state.initialized === true));
    const user = useUnit($global.map((state) => state.auth?.user));
    const isTempUser = TempUsersService.isTempUser(user?.attributes?.email || '');
    const purchasedPlanCode = useUnit($$auth.$currentParticipant.map((p) => p?.user?.plan?.plan_code));
    const estatePlan = useUnit($$ep.stores.$epQInstance);
    const isComplete = estatePlan?.status?.toLowerCase?.()?.includes?.('complete') ?? false;

    const successfullyPurchased = !!purchasedPlanCode || isComplete;

    const conditionsToShowModal = [
        !!(initialized && userRole === 'guest'),
        !!(initialized && userRole !== 'guest' && isTempUser),
        !!(initialized && userRole !== 'guest' && !isTempUser && !successfullyPurchased),
        !!(initialized && userRole !== 'guest' && !isTempUser && successfullyPurchased),
    ];

    const usersState = conditionsToShowModal?.indexOf(true);

    useEffect(() => {
        CookieService.setCookie(cookieName, `${usersState}`, 365 * 10);
    }, [usersState]);

    const promotionUserState = useCookieChange(cookieName);
    useEffect(() => {
        try {
            const needToShow = [0, 1, 2]?.includes(JSON.parse(promotionUserState ?? null));
            if (needToShow) {
                (document.querySelector('.popup-overlay') as HTMLElement).style.display = 'flex';
                CookieService.setCookie(cookieName, false, 1);
            }
        } catch (error) {
            // console.warn('Error while trying to open marketing modal');
        }
    }, [promotionUserState]);
};

export default useMarketingModalStates;
